import api from "./api";
import { BASE_URL_SEARCH } from "../constants";

export default class SearchApiCaller {
  static Get(endPoint = "", params = {}, headers = {}) {
    return api
      .get(`${BASE_URL_SEARCH}${endPoint}`, { params, headers })
      .then((res) => res)
      .catch((err) => err?.response);
  }

  static Post(endPoint = "", body = {}, headers = {}) {
    return api
      .post(`${BASE_URL_SEARCH}${endPoint}`, body, { headers })
      .then((res) => res)
      .catch((err) => err?.response);
  }

  static Put(endPoint = "", body = {}, headers = {}) {
    return api
      .put(`${BASE_URL_SEARCH}${endPoint}`, body, { headers })
      .then((res) => res)
      .catch((err) => err?.response);
  }

  static Delete(endPoint = "", body = {}, headers = {}) {
    return api
      .delete(`${BASE_URL_SEARCH}${endPoint}`, { data: body, headers })
      .then((res) => res)
      .catch((err) => err?.response);
  }
}
